import React from "react";
import Chart from "react-apexcharts";
import NoDataAvailable from "../../NoDataAvailable";

const AreaChartBasic = ({ data, custOptions }) => {
  const defOptions = {
    chart: {
      id: "basic-bar",
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      show: false,
    },
    legend: {
      show: true,
    },
    xaxis: {
      labels: { show: false },
    },
    yaxis: {
      labels: { show: false },
    },
  };
  return (
    <div>
      {data ? (
        <Chart
          options={custOptions ? custOptions : defOptions}
          series={data}
          type="area"
          height="400"
        />
      ) : (
        <NoDataAvailable />
      )}
    </div>
  );
};

export default AreaChartBasic;
